<template>
  <div class="home-container">
    <img class="gif-img" :src="appData.platformConfiguration.homePageGifImg" alt="" />

    <div class="home-modules" style="margin-top: 31px">
      <!-- 新闻动态 -->
      <div class="modules-item">
        <div class="modules-head">
          <div class="title-box">新闻动态</div>
          <div class="more-box" @click="jumpMore('新闻动态', '', 3)">
            <span>更多</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="modules-content">
          <el-carousel trigger="click" height="303px" class="modules-carousel">
            <el-carousel-item v-for="(item, i) in appData.newsList" :key="i">
              <div class="news-content" @click="jumpDetail(item)">
                <img :src="item.coverImg" alt="" />
                <div class="title-box">{{ item.title }}</div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <!-- 通知公告 -->
      <div class="modules-item">
        <div class="modules-head">
          <div class="title-box">通知公告</div>
          <div class="more-box" @click="jumpMore('通知公告', 13, 3)">
            <span>更多</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="modules-content">
          <div class="list-box">
            <div class="list-item" v-for="(item, i) in appData.announcementList" :key="i" @click="jumpDetail(item)">
              <div
                class="list-title"
                :style="{ color: item.isTop == 1 ? '#f40622' : '#333333', 'font-weight': item.isTop == 1 ? 'bold' : '400' }"
              >
                {{ item.title }}
              </div>
              <div
                class="list-time"
                :style="{ color: item.isTop == 1 ? '#f40622' : '#999', 'font-weight': item.isTop == 1 ? 'bold' : '400' }"
              >
                {{ item.releaseTime }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="home-modules" style="margin-top: 45px">
      <!-- 动态追踪 -->
      <div class="modules-item">
        <div class="modules-head">
          <div class="title-box">动态追踪</div>
          <div class="more-box" @click="jumpMore('动态追踪', 14, 3)">
            <span>更多</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="modules-content">
          <div class="list-box">
            <div class="list-item" v-for="(item, i) in appData.trackingtList" :key="i" @click="jumpDetail(item)">
              <div
                class="list-title"
                :style="{ color: item.isTop == 1 ? '#f40622' : '#333333', 'font-weight': item.isTop == 1 ? 'bold' : '400' }"
              >
                {{ item.title }}
              </div>
              <div
                class="list-time"
                :style="{ color: item.isTop == 1 ? '#f40622' : '#999', 'font-weight': item.isTop == 1 ? 'bold' : '400' }"
              >
                {{ item.releaseTime }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 会员风采 -->
      <div class="modules-item">
        <div class="modules-head">
          <div class="title-box">会员风采</div>
          <div class="more-box" @click="jumpMore('会员风采', 21, 7)">
            <span>更多</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="modules-content">
          <div class="list-box">
            <div class="list-item" v-for="(item, i) in appData.memberStyleList" :key="i" @click="jumpDetail(item)">
              <div
                class="list-title"
                :style="{ color: item.isTop == 1 ? '#f40622' : '#333333', 'font-weight': item.isTop == 1 ? 'bold' : '400' }"
              >
                {{ item.title }}
              </div>
              <div
                class="list-time"
                :style="{ color: item.isTop == 1 ? '#f40622' : '#999', 'font-weight': item.isTop == 1 ? 'bold' : '400' }"
              >
                {{ item.releaseTime }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="logos-qrcode-box">
      <div class="logo-img-box">
        <div class="logo-box" v-for="(item, i) in appData.photoList" :key="i">
          <div class="logo-item" v-for="(data, index) in item" :key="data.id">
            <img
              @click="jumpLink(data)"
              :style="{
                width: index === 0 ? '278px' : index === 1 ? '263px' : '429px',
                marginRight: index === item.length - 1 ? 'unset' : '18px',
              }"
              :src="data.url"
              alt=""
            />
          </div>
          <!-- <div class="logo-item" v-for="(item, i) in appData.photoDownList" :key="item.id">
            <img
              @click="jumpLink(item)"
              :style="{
                width: i === 0 ? '404px' : i === 1 ? '312px' : '257px',
                marginRight: i === appData.photoDownList.length - 1 ? 'unset' : '18px',
              }"
              :src="item.url"
              alt=""
            />
          </div> -->
        </div>
      </div>
      <div class="qrcode-box">
        <img :src="appData.platformConfiguration.homePageWxImg" alt="" />
        <span>微信二维码</span>
      </div>
    </div>

    <div class="home-modules" style="margin-top: 132px; margin-bottom: 353px">
      <!-- 质量安全 -->
      <div class="modules-item">
        <div class="modules-head">
          <div class="title-box">质量安全</div>
          <div class="more-box" @click="jumpMore('质量安全', '', 4)">
            <span>更多</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="modules-content">
          <div class="list-box">
            <div class="list-item" v-for="(item, i) in appData.safeProductionList" :key="i" @click="jumpDetail(item)">
              <div
                class="list-title"
                :style="{ color: item.isTop == 1 ? '#f40622' : '#333333', 'font-weight': item.isTop == 1 ? 'bold' : '400' }"
              >
                {{ item.title }}
              </div>
              <div
                class="list-time"
                :style="{ color: item.isTop == 1 ? '#f40622' : '#999', 'font-weight': item.isTop == 1 ? 'bold' : '400' }"
              >
                {{ item.releaseTime }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 文件链接 -->
      <div class="modules-item">
        <div class="modules-head">
          <div class="title-box">文件链接</div>
          <div class="more-box" @click="jumpMore('文件链接', 18, 5)">
            <span>更多</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="modules-content">
          <div class="list-box">
            <div class="list-item" v-for="(item, i) in appData.fileLinkList" :key="i" @click="jumpDetail(item)">
              <div
                class="list-title"
                :style="{ color: item.isTop == 1 ? '#f40622' : '#333333', 'font-weight': item.isTop == 1 ? 'bold' : '400' }"
              >
                {{ item.title }}
              </div>
              <div
                class="list-time"
                :style="{ color: item.isTop == 1 ? '#f40622' : '#999', 'font-weight': item.isTop == 1 ? 'bold' : '400' }"
              >
                {{ item.releaseTime }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndex } from "@/api/common.js";

export default {
  data() {
    return {};
  },
  computed: {
    appData() {
      return this.$store.state.appState.appData;
    },
  },
  mounted() {},
  methods: {
    jumpMore(title, id, parentId) {
      this.$router.push({ name: "more", query: { title: title, id: id, parentId: parentId, from: "/" } });
    },
    jumpDetail(item) {
      this.$router.push({ name: "detail", query: { id: item.id, from: "/" } });
    },
    jumpLink(item) {
      window.open(item.link, "_blank");
    },
  },
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
@/api/common.js
